import { render, staticRenderFns } from "./Tunnel.vue?vue&type=template&id=86b801d8&"
import script from "./Tunnel.vue?vue&type=script&lang=js&"
export * from "./Tunnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports